import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@global/button/Button'

import { DialogModal } from '../DialogModal'
import type { CommonModalTitleProps, ModalProps } from '../types'

interface DataListModalProps extends PropsWithChildren<CommonModalTitleProps & ModalProps> {
  isLoading?: boolean
  renderFooter?(props: DataListModalProps): React.ReactNode[]
}

export const DataListModalDesktop: React.FC<DataListModalProps> = (props) => {
  const { title, isLoading = false, children, renderFooter, onClose } = props

  const { t } = useTranslation()

  return (
    <DialogModal
      {...props}
      title={title}
      isLoading={isLoading}
      renderFooter={({ onClose }) =>
        renderFooter?.({ ...props, onClose }) || [
          <Button appearance='primary' onClick={onClose}>
            {t('Close')}
          </Button>,
        ]
      }
      onClose={onClose}
    >
      {children}
    </DialogModal>
  )
}
